import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon_inquiry_image.png'
import _imports_1 from '@/assets/images/icon_used_foods.png'
import _imports_2 from '@/assets/images/food_noimage.png'
import _imports_3 from '@/assets/images/search_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-223b9af5")

_pushScopeId("data-v-223b9af5")
const _hoisted_1 = { class: "mypage-reports" }
const _hoisted_2 = {
  key: 0,
  class: "mypage-reports-inquiry"
}
const _hoisted_3 = { class: "commonCard mypage-reports-inquiry-card" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "mypage-reports-inquiry-card-image",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "mypage-reports-inquiry-card-description" }
const _hoisted_6 = { class: "mypage-reports-inquiry-card-description-text" }
const _hoisted_7 = {
  key: 1,
  class: "mypage-reports-usedfoods"
}
const _hoisted_8 = { class: "mypage-reports-usedfoods-card-title" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "mypage-reports-usedfoods-card-title-image",
  src: _imports_1
}, null, -1)
const _hoisted_10 = { class: "mypage-reports-usedfoods-card-title-title" }
const _hoisted_11 = { class: "mypage-reports-usedfoods-card-title-title-text" }
const _hoisted_12 = { class: "mypage-reports-usedfoods-card-list" }
const _hoisted_13 = {
  key: 0,
  class: "mypage-reports-usedfoods-card-list-exist"
}
const _hoisted_14 = { class: "mypage-reports-usedfoods-card-list-exist-message" }
const _hoisted_15 = { class: "mypage-reports-usedfoods-card-list-exist-message-text" }
const _hoisted_16 = { class: "mypage-reports-usedfoods-card-list-exist-foodlist" }
const _hoisted_17 = { class: "mypage-reports-usedfoods-card-list-exist-foodlist-item-badge" }
const _hoisted_18 = { class: "mypage-reports-usedfoods-card-list-exist-foodlist-item-badge-text" }
const _hoisted_19 = {
  key: 1,
  class: "mypage-reports-usedfoods-card-list-notexist"
}
const _hoisted_20 = { class: "mypage-reports-usedfoods-card-list-notexist-text" }
const _hoisted_21 = { class: "mypage-reports-usedfoods-card-userranking" }
const _hoisted_22 = { class: "mypage-reports-usedfoods-card-userranking-title" }
const _hoisted_23 = { class: "mypage-reports-usedfoods-card-userranking-title-text" }
const _hoisted_24 = { class: "mypage-reports-usedfoods-card-userranking-contents" }
const _hoisted_25 = {
  key: 0,
  class: "mypage-reports-usedfoods-card-userranking-contents-noranking"
}
const _hoisted_26 = { class: "mypage-reports-usedfoods-card-userranking-contents-noranking-textarea" }
const _hoisted_27 = { class: "mypage-reports-usedfoods-card-userranking-contents-noranking-textarea-text" }
const _hoisted_28 = {
  key: 1,
  class: "mypage-reports-usedfoods-card-userranking-contents-ranking"
}
const _hoisted_29 = { class: "mypage-reports-usedfoods-card-userranking-contents-ranking-textarea" }
const _hoisted_30 = { class: "mypage-reports-usedfoods-card-userranking-contents-ranking-textarea-prevalue" }
const _hoisted_31 = { class: "mypage-reports-usedfoods-card-userranking-contents-ranking-textarea-prevalue-text" }
const _hoisted_32 = { class: "mypage-reports-usedfoods-card-userranking-contents-ranking-textarea-value" }
const _hoisted_33 = { class: "mypage-reports-usedfoods-card-userranking-contents-ranking-textarea-value-text" }
const _hoisted_34 = { class: "mypage-reports-usedfoods-card-userranking-contents-ranking-textarea-postvalue" }
const _hoisted_35 = { class: "mypage-reports-usedfoods-card-userranking-contents-ranking-textarea-postvalue-text" }
const _hoisted_36 = {
  key: 2,
  class: "mypage-reports-historyrecipe"
}
const _hoisted_37 = { class: "mypage-reports-historyrecipe-card-title" }
const _hoisted_38 = /*#__PURE__*/_createVNode("img", {
  class: "mypage-reports-historyrecipe-card-title-image",
  src: _imports_3
}, null, -1)
const _hoisted_39 = { class: "mypage-reports-historyrecipe-card-title-title" }
const _hoisted_40 = { class: "mypage-reports-historyrecipe-card-title-title-text" }
const _hoisted_41 = { class: "mypage-reports-historyrecipe-card-contents" }
const _hoisted_42 = {
  key: 0,
  class: "mypage-reports-historyrecipe-card-contents-nohistory"
}
const _hoisted_43 = { class: "mypage-reports-historyrecipe-card-contents-nohistory-text" }
const _hoisted_44 = {
  key: 1,
  class: "mypage-reports-historyrecipe-card-contents-history"
}
const _hoisted_45 = { class: "mypage-reports-historyrecipe-card-contents-history-description" }
const _hoisted_46 = { class: "mypage-reports-historyrecipe-card-contents-history-description-text" }
const _hoisted_47 = { class: "mypage-reports-historyrecipe-card-contents-history-recipe" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isValidInquiry)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.inquiryDescriptionText), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isValidUsedFoods)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", {
            class: "commonCard mypage-reports-usedfoods-card",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickUsedFoods(...args)))
          }, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode("span", _hoisted_11, _toDisplayString(_ctx.usedFoodsTitleText), 1)
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              (_ctx.isExistUsedFoodList)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.numberOfUsedFoodsText), 1)
                    ]),
                    _createVNode("div", _hoisted_16, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayUsedFoodList, (item) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "mypage-reports-usedfoods-card-list-exist-foodlist-item",
                          key: item.foodId,
                          style: _ctx.usedFoodListItemImageSize
                        }, [
                          (item.image)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                class: "mypage-reports-usedfoods-card-list-exist-foodlist-item-image",
                                src: item.image,
                                style: _ctx.usedFoodListItemImageSize,
                                onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFoodImageError(...args)))
                              }, null, 44, ["src"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                class: "mypage-reports-usedfoods-card-list-exist-foodlist-item-image",
                                src: _imports_2,
                                style: _ctx.usedFoodListItemImageSize
                              }, null, 4)),
                          _createVNode("div", _hoisted_17, [
                            _createVNode("span", _hoisted_18, _toDisplayString(item.consumeCount), 1)
                          ])
                        ], 4))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_19, [
                    _createVNode("span", _hoisted_20, _toDisplayString(_ctx.noExistUsedFoodListText), 1)
                  ]))
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.userRankingtitleText), 1)
              ]),
              _createVNode("div", _hoisted_24, [
                (_ctx.isNoRankingPreviousMonth)
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _createVNode("span", _hoisted_27, _toDisplayString(_ctx.noUserRankingText), 1)
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode("div", _hoisted_30, [
                          _createVNode("span", _hoisted_31, _toDisplayString(_ctx.preRankingValueText), 1)
                        ]),
                        _createVNode("div", _hoisted_32, [
                          _createVNode("span", _hoisted_33, _toDisplayString(_ctx.rankingValueText), 1)
                        ]),
                        _createVNode("div", _hoisted_34, [
                          _createVNode("span", _hoisted_35, _toDisplayString(_ctx.postRankingValueText), 1)
                        ])
                      ])
                    ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isValidHistoryRecipe)
      ? (_openBlock(), _createBlock("div", _hoisted_36, [
          _createVNode("div", {
            class: "commonCard mypage-reports-historyrecipe-card",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickHistoryRecipe(...args)))
          }, [
            _createVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode("div", _hoisted_39, [
                _createVNode("span", _hoisted_40, _toDisplayString(_ctx.historyRecipeTitleText), 1)
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              (_ctx.isNoHistory)
                ? (_openBlock(), _createBlock("div", _hoisted_42, [
                    _createVNode("span", _hoisted_43, _toDisplayString(_ctx.noHistoryMessageText), 1)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, [
                      _createVNode("span", _hoisted_46, _toDisplayString(_ctx.historyRecipeDescriptionText), 1)
                    ]),
                    _createVNode("div", _hoisted_47, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recipeImageList, (image) => {
                        return (_openBlock(), _createBlock("div", { key: image }, [
                          _createVNode("img", {
                            class: "mypage-reports-historyrecipe-card-contents-history-recipe-image",
                            src: image,
                            style: _ctx.historyRecipeImageSize,
                            onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
                          }, null, 44, ["src"])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})